/* This helper class is used to create a DataSerie object */
class DataSerie {
  /**
   * Create a DataSerie object
   * @param {String} name dataSerie name
   * @param {Array} xValues X values
   * @param {Array} yValues Y values
   * @param {String} color color associated to the dataSerie
   * @param {String} label label associated to the dataSerie
   * @param {boolean} isAStdDevDataSerie whether this dataSerie corresponds to standard deviation.
   */
  constructor(name, xValues, yValues, color, label, isAStdDevDataSerie) {
    this.name = name
    this.color = color
    this.label = label
    this.isAStdDevDataSerie = isAStdDevDataSerie

    if (xValues instanceof Array && yValues instanceof Array && xValues.length === yValues.length) {
      this.x = xValues
      this.y = yValues
    } else {
      this.x = []
      this.y = []
    }
  }

  get values() {
    return {
      name: this.name,
      x: this.x,
      y: this.y,
      color: this.color,
      label: this.label,
      isAStdDevDataSerie: this.isAStdDevDataSerie,
    }
  }

  updateXYValues(xValues, yValues) {
    if (
      xValues &&
      yValues &&
      xValues instanceof Array &&
      yValues instanceof Array &&
      xValues.length === yValues.length
    ) {
      this.x = xValues
      this.y = yValues
    }
  }

  /**
   * Push a point at the end of the data serie
   * @param {integer} xValue x value of the point
   * @param {integer} yValue y value of the point
   */
  pushPoint(xValue, yValue) {
    if (xValue !== undefined && xValue !== null && !Number.isNaN(xValue)) {
      if (isNaN(yValue) === false) {
        this.x.push(xValue)
        this.y.push(yValue)
      } else {
        this.x.push(xValue)
        this.y.push(NaN)
      }
    }
  }

  /**
   * Adds a point at a given index of the data serie
   * @param {integer} xValue x value of the point
   * @param {integer} yValue y value of the point
   * @param {*} index index to add the point to
   */
  addPointByIndex(xValue, yValue, index) {
    if (index >= 0 && index <= this.x.length) {
      if (xValue && !Number.isNaN(yValue) && yValue !== undefined && yValue !== null) {
        this.x.splice(index, 0, xValue)
        this.y.splice(index, 0, yValue)
      } else if (xValue && !yValue) {
        this.x.splice(index, 0, xValue)
        this.y.splice(index, 0, NaN)
      }
    }
  }

  /**
   * Transform the x and y dataseries to workaround a plotly bug which prevents filled fragmented scatter to be plotted properly. See tests for details
   */
  plotLiWorkAround() {
    let i = 1
    while (i < this.x.length - 1) {
      if (Number.isNaN(this.y[i])) {
        this.y.splice(i, 1, 0, this.y[i], 0)
        this.x.splice(i, 1, this.x[i - 1], this.x[i], this.x[i + 1])
        i = i + 3
      } else {
        i++
      }
    }
    return this
  }
}

export default DataSerie
